import 'reflect-metadata';

export const META_CLIENT = Symbol('client');
export const META_BASE_PATH = Symbol('base_path');

export function APIResource(client: object, basePath: string): ClassDecorator {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
  return (target: Function) => {
    Reflect.defineMetadata(META_CLIENT, client, target.prototype);
    Reflect.defineMetadata(META_BASE_PATH, basePath, target.prototype);
  };
}
